<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.0865 17.873L26.5865 24.123C26.399 26.0355 26.249 27.498 22.8615 27.498H7.13648C3.74898 27.498 3.59898 26.0355 3.41148 24.123L2.91148 17.873C2.81148 16.8355 3.13648 15.873 3.72398 15.1355C3.73648 15.123 3.73648 15.123 3.74898 15.1105C4.43648 14.273 5.47398 13.748 6.63648 13.748H23.3615C24.524 13.748 25.549 14.273 26.224 15.0855C26.2365 15.098 26.249 15.1105 26.249 15.123C26.8615 15.8605 27.199 16.823 27.0865 17.873Z" stroke="#F0783B" stroke-width="2" stroke-miterlimit="10"/>
    <path d="M4.37598 14.2891V7.85156C4.37598 3.60156 5.43848 2.53906 9.68848 2.53906H11.276C12.8635 2.53906 13.226 3.01406 13.826 3.81406L15.4135 5.93906C15.8135 6.46406 16.051 6.78906 17.1135 6.78906H20.301C24.551 6.78906 25.6135 7.85156 25.6135 12.1016V14.3391" stroke="#F0783B" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.7881 21.248H18.2131" stroke="#F0783B" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
